// @flow
import type { Reducer } from 'redux';

import { checkActionIsRouteAction } from 'modules/router/helpers';

export function clearableRoutedReducer<S: *, A: *>(routeType: string | string[]) {
  return (clearAction: A, reducer: Reducer<S, A>) => (state: S, action: A) => {
    if (checkActionIsRouteAction(action)) {
      if (
        (typeof routeType === 'string' && action.type !== routeType) ||
        (Array.isArray(routeType) && routeType.reduce((acc, i) => acc && action.type !== i, true))
      ) {
        return reducer(state, clearAction);
      }
    }

    return reducer(state, action);
  };
}

export default clearableRoutedReducer;



// WEBPACK FOOTER //
// ./src/store/helpers/clearableRoutedReducer.js